/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Length_HelpInputs */



/**
* | output |
* | --- |
* | "Choose how long each generated description should be." |
*
* @param {Ad_Description_Length_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_length_help = /** @type {((inputs?: Ad_Description_Length_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Length_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez la longueur de chaque description générée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Länge der einzelnen generierten Beschreibungen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli la lunghezza di ciascuna descrizione generata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите длину каждого сгенерированного описания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige la longitud que debe tener cada descripción generada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择每条生成的描述的长度。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("生成される各説明文の長さを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्येक जनरेट किए गए विवरण की लंबाई चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha o tamanho desejado para cada descrição gerada.")
	return /** @type {LocalizedString} */ ("Choose how long each generated description should be.")
});